// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"260": "ec5c59371e27","6638": "a7c322f609c8",}[chunkId] + ".css"
}